<template>
	<modal name="event-registration-agreement-modal" :scrollable="true" :adaptive="true" :height="'auto'">
		<div class="container-fluid wa-modal">

			<!-- Modal Header Start -->
			<div class="row wa-modal-header">
				<div class="col-md-12">
					<h2>
						{{ $t('event_registration.tos_modal_title') }}
					</h2>
				</div>
			</div>
			<!-- Modal Header End -->

			<!-- Modal Body Start -->
			<div class="row">
				<div class="col-md-12">
					<div v-html="event.tos_text"></div>
				</div>
			</div>
			<!-- Modal Body Start -->

			<!-- Modal Footer Start -->
			<footer class="row wa-modal-footer wa-modal-footer-white">
				<div class="col-md-12">
					<div class="pull-right">
						<a href="#" v-on:click.prevent="close" id="agreement-modal-close-button" class="btn btn-default btn-inverted">
							{{ $t('common.close') }}
						</a>
					</div>
				</div>
			</footer>
			<!-- Modal Footer Start -->

		</div>
	</modal>
</template>

<script>
export default {
	name: 'EventRegistrationAgreementModal',
	props: {
		event: {
			type: Object,
			required: true,
			default: function() {
				return {
					event: {
						tos_text:''
					}
				}
			}
		}
	},
	methods: {
		close() {
			this.$modal.hide('event-registration-agreement-modal');
		},
	}
}
</script>
